import {Dispatch} from 'redux'
import Swal from 'sweetalert2'
import {patchRequest} from '../../../setup/redux/common/cruds'
import {useNavigate} from 'react-router-dom'
import {useQueryClient} from 'react-query'
import {useQueryResponse} from '../../modules/notifications/notifications-list/core/QueryResponseProvider'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {setActiveCompany} from '../../../setup/redux/auth/slices'
import {getNotificationList} from '../../../setup/redux/notifications/actions'
import {IsRootUserOrAdmin, mergeTrailingTextForCKEditor} from '../Functional'
import {handleIsOrderAPICalledByID} from '../../../setup/redux/orders/actions'
import {setActiveTab} from '../../../setup/redux/tabs/slices'

const ReadNotification = ({notification}: any) => {
  const {id, title, description, is_read, order} = notification
  const isSuperAdminUser = IsRootUserOrAdmin()
  const {query} = useQueryResponse()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const dispatch: Dispatch<any> = useDispatch()
  const module = 'notifications'
  const {inspection_companies}: any = useSelector<RootState>(
    (state) => ({
      inspection_companies: state.auth.inspection_companies,
      company: state.auth.company,
    }),
    shallowEqual
  )

  const handleConfirmation = async (result: any) => {
    if (result.isConfirmed && !is_read) {
      try {
        await patchRequest(`${process.env.REACT_APP_API_BASE_URL}notifications/${id}`, [])
        await queryClient.invalidateQueries([`${module}-${query}`])
        dispatch(getNotificationList())
        if (isSuperAdminUser && order.status === 'Pending') {
          dispatch(setActiveCompany(inspection_companies[0]))
          dispatch(handleIsOrderAPICalledByID(true))
          dispatch(setActiveTab({module: 'Orders', index: 0}))
          navigate(`/manage-orders`, {
            state: {id: order.id},
          })
        }
      } catch (error: any) {
        error.clientMessage = "Can't update site"
        alert(error.clientMessage)
      }
    } else if (result.isConfirmed && isSuperAdminUser && order && order.status === 'Pending') {
      dispatch(setActiveCompany(inspection_companies[0]))
      dispatch(handleIsOrderAPICalledByID(true))
      dispatch(setActiveTab({module: 'Orders', index: 0}))
      navigate(`/manage-orders`, {
        state: {id: order.id},
      })
    }
  }

  const handleReadNotification = () => {
    Swal.fire({
      icon: 'success',
      width: 600,
      html: `
      <div class='preview m-0'>
        ${mergeTrailingTextForCKEditor(title)}
      </div>
      <div class='preview m-0 mt-2'>
        ${mergeTrailingTextForCKEditor(description)}
      </div>
    `,
      confirmButtonText: `${isSuperAdminUser && order && order.status === 'Pending' ? 'Process Order' : 'Ok'}`,
      confirmButtonColor: '#061bb0',
      allowOutsideClick: false,
    }).then(handleConfirmation)
  }

  return (
    <a
      onClick={handleReadNotification}
      role='button'
      className={`menu-link p-0 d-inline fs-6 fw-bolder he ${is_read ? 'text-gray-400' : 'text-black text-hover-primary'}`}
    >
      <div
        className={`preview m-0 ${is_read ? 'text-gray-400' : 'text-black text-hover-primary'}`}
        dangerouslySetInnerHTML={{__html: mergeTrailingTextForCKEditor(title)}}
      ></div>
    </a>
  )
}

export default ReadNotification
